import dayjs from 'dayjs';

// Pure datetime formatting helpers. Kept in their own module (with no service /
// DOM imports) so they can be unit-tested without a browser environment.

export const formatDateTime = (d: dayjs.Dayjs) => {
  return d.local().format('MM/DD/YY HH:mm:ss');
};

// Formats a Date or no-offset datetime string as the user's wall-clock time, with
// no timezone conversion. Used for fields like commitmentDate where the stored
// value represents an exact wall-clock moment and must round-trip unchanged.
export const formatLocalDateTime = (value: Date | string | undefined) => {
  if (value === undefined || value === null) {
    return undefined;
  }
  return formatDateTime(dayjs(value));
};
